import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
function Dashboard() {

    const navigate = useNavigate();
    const handleLogout = () => {

  localStorage.removeItem("token");

  navigate("/admin/login");

};

  return (
    <section className="min-h-screen bg-[#F5F7FA] pt-28 px-8 md:px-14 pb-14">

      {/* HEADING */}
      <div className="flex justify-between items-start mb-12">

  <div>
    <p className="uppercase tracking-[5px] text-yellow-600 font-semibold text-sm mb-3">
      Admin Panel
    </p>

    <h1 className="text-5xl font-bold text-[#0B1C39]">
      Dashboard
    </h1>
  </div>

  <button
    onClick={handleLogout}
    className="bg-red-500 text-white px-6 py-3 rounded-2xl font-semibold hover:bg-red-600 transition"
  >
    Logout
  </button>

</div>
      {/* GRID */}
      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">

        {/* CARD */}
        <Link
          to="/admin/create-post"
          className="bg-white rounded-[30px] p-10 shadow-lg hover:shadow-2xl transition duration-300 hover:-translate-y-2"
        >

          <h2 className="text-2xl font-bold text-[#0B3D91] mb-4">
            Create Post
          </h2>

          <p className="text-gray-600 leading-relaxed">
            Publish blogs, legal guides, updates,
            FAQs and case studies.
          </p>

        </Link>

        {/* CARD */}
        <Link
          to="/admin/posts"
          className="bg-white rounded-[30px] p-10 shadow-lg hover:shadow-2xl transition duration-300 hover:-translate-y-2"
        >

          <h2 className="text-2xl font-bold text-[#0B3D91] mb-4">
            Manage Posts
          </h2>

          <p className="text-gray-600 leading-relaxed">
            Edit, delete and manage all published content.
          </p>

        </Link>

      </div>

      
      


    </section>
    
  );
}

export default Dashboard;